export default "__VITE_ASSET__BsTDQ_uw__";